import kundoImg from '../../img/Tyck_till_small.png';

window._kundo = {
    "image": kundoImg,
    "top": "200px",
    "org": "vattenweb",
    "lang": "sv",
    "image_alt": "Tyck till",
    "open_startpage": true,
    "target": "_blank",
};
